export default {
    props: {
        field: {
            type: Object,
        },
        value: {
            type: Object,
        }
    },
    data() {
        if (this.value && this.value[this.field.key] === undefined) {
            this.$set(this.value, this.field.key, null)
        }
        return {
            my_value: this.value
        }
    },
    watch: {
        value(new_val) {
            this.my_value = new_val
        },
        my_value(new_val) {
            this.$emit('input', new_val)
        }
    },
}